import { render, staticRenderFns } from "./device_history.vue?vue&type=template&id=b81408e8&scoped=true&"
import script from "./device_history.vue?vue&type=script&lang=js&"
export * from "./device_history.vue?vue&type=script&lang=js&"
import style0 from "./device_history.vue?vue&type=style&index=0&id=b81408e8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81408e8",
  null
  
)

export default component.exports